export interface PaginationItems<T> {
  totalItems: number;
  items: T[];
  pageCount: number;
}

export const DefaultPaginationItems = () => {
  return {
    totalItems: 0,
    pageCount: 0,
    items: [],
  };
};

export interface PaginatedRequest {
  page: number;
  take: number;
  orderBy?: string;
  isDescending?: boolean;
}

export const DefaultPaginatedRequest = () => {
  return {
    take: defaultTake,
    page: 1,
    orderBy: undefined,
    isDescending: undefined,
    singleUseLocation: false,
  };
};

export interface PaginatedSelectListResponse {
  id: number;
  name: string;
}

export const defaultTake = 15;
export const mediumTableTake = 10;
export const smallTableTake = 5;
